// extracted by mini-css-extract-plugin
export default {"form":"ProfilePage_form__Iw2C-","form_li":"ProfilePage_form_li__OXtaB","buttons":"ProfilePage_buttons__sinKx"};